import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=0cb698cd&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cb698cd')) {
      api.createRecord('0cb698cd', component.options)
    } else {
      api.reload('0cb698cd', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=0cb698cd&", function () {
      api.rerender('0cb698cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-28QpKa5ZCELR2/JS/offershelp.vue"
export default component.exports